import React, { Component } from 'react';
import { Modal, message, Spin } from 'antd';
import FormList from '../../../basicElement/FormList';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';
import { getMatchOption } from '../../../shared/selectFn';
import moment from 'moment';

const defaultOptions = [
    { label: '是', value: '1' },
    { label: '否', value: '0' }
];

class UpdateReturnedProgress extends Component {
    state = {
        data: {},
        visible: false,
        loading: false,
        receivingAmountList:[],
        receivingAmountReasonList:[],
        edit: false,
    }

    show = (record) => {
        const {
            remittanceCode,
            contractRemittanceApplicationId,
            progressId,
            progressRemark,
            expectedBackMonth,
            specificDescription,
            isReceivingDifficult,
            receivingStopBreathingCode,
            receivingStopBreathingId,
            receivingDate,
            receiveAmountIncludeTax,
            receiveInstallmentRemarks,
        } = record;
        this.setState({
            visible: true,
            edit: receiveInstallmentRemarks ? true : false,
            data: {
                remittanceCode,
                contractRemittanceApplicationId,
                progressId,
                progressRemark,
                expectedBackMonth,
                specificDescription,
                isReceivingDifficult,
                receivingStopBreathingCode,
                receivingStopBreathingId,
                receivingDate: receivingDate ? moment(receivingDate).format('YYYY-MM-DD') : undefined,
                receiveAmountIncludeTax,
                receiveInstallmentRemarks,
            },
    },() => {
        this.queryStopBreathingCode();
        if(this.state.data.receivingStopBreathingCode) this.queryStopBreathingReason(this.state.data.receivingStopBreathingCode);
    });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    queryStopBreathingCode = () => {
        Fetch.post(API_URL.contract.queryStopBreathingCode, { type:'receivingAmount'}).then(res => {
            const { data = [] } = res;
            this.setState({  receivingAmountList: data });
        }).catch(error => {
            console.error(error);
        });
    }
    
    queryStopBreathingReason = (code) => {
        Fetch.post(API_URL.contract.queryStopBreathingReason, {type:'receivingAmount',code}).then(res => {
            const { data = [] } = res;
            this.setState({  receivingAmountReasonList: data });
        }).catch(error => {
            console.error(error);
        });
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        switch (key) {
            case 'progressId':
                data.progressRemark = undefined;
                data[key] = value;
                break;
            case 'receivingStopBreathingCode' :
                data.receivingStopBreathingId = undefined;
                value && this.queryStopBreathingReason(value)
                data[key] = value;
                break;
            case 'receiveAmountIncludeTax':
                this.setState({ edit: true });
                data[key] = value;
                break;
            default:
                data[key] = value;
                break;
        }
        this.setState({ data });
    }

    getColumns = () => {
        const { returnedProgressList } = this.props;
        const { data, receivingAmountList, receivingAmountReasonList, edit } = this.state;
        const { progressId } = data;

        const showOther = getMatchOption(returnedProgressList, 'typeConfigureId', progressId).typeValue === '其他';
        const returnedProgressOption = returnedProgressList.map(i => ({ label: i.typeValue, value: i.typeConfigureId }));
        const receivingAmountOption = receivingAmountList.map(i => ({ label: i.code, value: i.code }));
        const receivingAmountReasonOption = receivingAmountReasonList.map(i => ({ label: i.reason, value: i.stopBreathingId }));
        

        // 字段属性配置
        const columns = [{
            name: '请款单号',
            key: 'remittanceCode',
            type: 'text',
        }, {
            name: '回款金额含税额',
            key: 'receiveAmountIncludeTax',
            type: 'inputNumber',
            typeProperty: {
                style: { width: 240 },
                precision: 2,
            },
            rules: {
                required: true,
                colon: true,
            }
        }, {
            name: <span>&nbsp;</span>,
            key: 'receiveInstallmentRemarks',
            type: 'input',
            typeProperty: {
                style: { width: 240 },
                placeholder: '分期回款备注说明',
            },
            rules: {
                display: edit,
                colon: false,
            }
        }, {
            name: '回款进度',
            key: 'progressId',
            type: 'select',
            typeProperty: {
                style: { width: 240 },
                list: returnedProgressOption,
            },
        }, {
            name: <span>&nbsp;</span>,
            key: 'progressRemark',
            type: 'input',
            typeProperty: {
                style: { width: 240 },
                placeholder: '请填写其他备注说明',
            },
            rules: {
                display: showOther,
                msg: '请填写其他备注说明',
                colon: false,
            }
        }, {
            name: '预计回款月份',
            key: 'expectedBackMonth',
            type: 'monthPicker',
            typeProperty: {
                style: { width: 240 },
            },
        }, {
            name: '是否回款疑难',
            key: 'isReceivingDifficult',
            type: 'select',
            typeProperty: {
                style: { width: 240 },
                list: defaultOptions,
            },
        }, {
            name: '回款卡脖子节点',
            key: 'receivingStopBreathingCode',
            type: 'select',
            typeProperty: {
                style: { width: 240 },
                list: receivingAmountOption,
            },
        }, {
            name: '回款进度具体描述',
            key: 'receivingStopBreathingId',
            type: 'select',
            rules: {
                required: data.receivingStopBreathingCode,
            },
            typeProperty: {
                style: { width: 240 },
                list: receivingAmountReasonOption,
            },
        }, 
        // {
        //     name: '更新回款进度日期',
        //     key: 'receivingDate',
        //     type: 'datePicker',
        //     typeProperty: {
        //         style: { width: 240 },
        //     },
        // }, 
    ];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key } = column;
                const typeProperty = column.typeProperty || (column.typeProperty = {});
                typeProperty.canEdit = true;
                typeProperty.value = data[key];
            });
        }
        traverseColumns(columns);

        return columns;
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.saveBackProgress, data).then(res => {
            message.success(res.success);
            this.setState({  loading: false, }, () => {
                this.hide();
                this.props.loadData();
            });
        }).catch(() => {
            this.setState({ loading: false });
        });
    }

    render() {
        const { loading, visible } = this.state;
        return (
            <Modal
                title="更新回款进度"
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                className="create-modal EditPersonModal"
                maskClosable={false}
                width="600px"
                confirmLoading={loading}
            >
                <Spin spinning={loading}>
                    <FormList
                        className="form-list registerStartUp-list"
                        columns={this.getColumns()}
                        onChange={this.handleChange}
                        ref={el => this.formRef = el}
                    />
                </Spin>
            </Modal>
        );
    }
}

export default UpdateReturnedProgress;


// WEBPACK FOOTER //
// ./src/components/contractManagement/requestRecord/components/UpdateReturnedProgress.js